import { render } from "./FormTextFieldComponent.vue?vue&type=template&id=51bf1481&scoped=true"
import script from "./FormTextFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormTextFieldComponent.vue?vue&type=script&lang=js"

import "./FormTextFieldComponent.vue?vue&type=style&index=0&id=51bf1481&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bf1481"]])

export default __exports__